{
  "periods.toolbar": "Zaman çizgisi denetimleri",
  "periods.viewport_start": "Görünen başlangıç",
  "periods.viewport_end": "Görünen bitiş",
  "periods.apply": "Uygula",
  "periods.navigate": "Gezinme",
  "periods.custom": "Özel",
  "periods.months_one": "1 ay",
  "periods.months_other": "{{count}} ay",
  "periods.years_one": "1 yıl",
  "periods.years_other": "{{count}} yıl",
  "periods.invalid_range": "Aralarında en fazla 15 yıl olan geçerli bir başlangıç ve bitiş girin.",
  "periods.range_limited": "15 yıllık bir aralık gösteriliyor. Diğer dönemleri görmek için tarih aralığını değiştirin.",
  "periods.continues_before": "Görünen aralıktan önce devam ediyor",
  "periods.continues_after": "Görünen aralıktan sonra devam ediyor",
  "periods.snap_today": "Bugüne hizalandı · {{date}}",
  "periods.snap_status": "{{range}} · {{snap}}",
  "periods.planned_start": "Planlanan başlangıç",
  "periods.planned_end": "Planlanan bitiş",
  "periods.quick_dates": "Planlanan tarihler",
  "periods.save": "Kaydet",
  "periods.cancel": "Vazgeç",
  "periods.unsaved_dates": "Kaydedilmemiş planlanan tarihler silinsin mi?",
  "periods.discard": "Değişiklikleri sil",
  "periods.keep_editing": "Düzenlemeye devam et",
  "periods.date_error": "Tarihler kaydedilemedi. Değişiklikleriniz korunuyor.",
  "periods.dates_saved": "Planlanan tarihler kaydedildi.",
  "periods.drop_needs_dates": "Bilinen tarih bu görünümün dışında. Dönemi yerleştirmek için planlanan tarihleri düzenleyin.",
  "periods.gesture_hint": "Taşımak için sürükleyin · Görünen ucu tutarak boyutlandırın · Hassas hareket için Shift · Ok tuşları bir gün taşır",
  "periods.unsaved_dates_title": "Kaydedilmemiş planlanan tarihler",
  "periods.unsaved_dates_description": "Ayrılmadan önce tarihleri kaydedebilir, değişikliklerden vazgeçebilir veya düzenlemeye devam edebilirsiniz."
}
